import styled from 'styled-components'

export const StyledFullPageModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  background: radial-gradient(
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.6)
  );
  overflow: scroll;
`

export const StyledFullPageModalContent = styled.div`
  max-width: 575px;
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.bgCard};

  .modal-close {
    position: absolute;
    top: 19px;
    right: 17px;
    width: 25px;
    height: 25px;
    cursor: pointer;
    z-index: 1;
  }

  @media screen and (max-width: 640px) {
    width: 100%;
    max-width: 100%;
    bottom: 0;
    border-radius: 16px 16px 0 0;
    top: auto;
    right: 0;
    left: 0;
    transform: translate(0%, 0%);

    .modal-close {
      top: 15px;
      right: 15px;
      width: 25px;
      height: 25px;
      padding: 5px;
      z-index: 1000;
    }
  }
`

export const StyledFullPageModalContentOverlay = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10000;
`
